module.exports = __webpack_public_path__ + "media/images/icon__minus@3x-a61cdd478a1a74c19f0f78853bdbc7b3.png";